import { render, staticRenderFns } from "./appraise.vue?vue&type=template&id=210427a2&scoped=true&"
import script from "./appraise.vue?vue&type=script&lang=js&"
export * from "./appraise.vue?vue&type=script&lang=js&"
import style0 from "./appraise.vue?vue&type=style&index=0&id=210427a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210427a2",
  null
  
)

export default component.exports